export default () => {
    const faqItems = document.querySelectorAll('.faq__item');

        if(faqItems) {
            faqItems.forEach(item => {
                item.addEventListener('click', () => {
                    item.classList.toggle('is-active');

                });
            });
        }
}
